import { useNotificationCenter } from "../context/NotificationContext";

export const SUPPORT_CHAT_REFRESH_EVENT = "buzzerklip:support-chat-refresh";

const SUPPORT_CHAT_ROLES = new Set(["creator", "brand", "client"]);

export default function useSupportChatNotifications(user, { limit = 5 } = {}) {
  const { support, refresh: refreshNotifications } = useNotificationCenter();
  const canLoad = Boolean(user && user !== false && SUPPORT_CHAT_ROLES.has(user.role));
  const summary = canLoad && support ? support : { unread_count: 0, unread_tickets: [] };

  const unreadTickets = Array.isArray(summary.unread_tickets)
    ? summary.unread_tickets.slice(0, limit)
    : [];

  return {
    summary,
    unreadCount: Number(summary.unread_count || 0),
    unreadTickets,
    refresh: () => refreshNotifications({ force: true }),
  };
}
